import React from "react";

function SvgIcMapPoi127(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M26 15.003c1 0 2 1 2 1.997v2c0 1-1 2-2 2v2h-2v-2h-4v2h-2v-2c-1 0-2-1-2-2v-2c0-1 1-1.997 2-1.997zM13.5 4.998c.594 0 1.106.346 1.349.847l.006.01c.142.284 1.153 2.282 2.315 4.578.338-.452.627-.836.662-.876l.098-.109a1.494 1.494 0 012.157.018c.022.02.175.216.22.297.213.308 1.28 2.138 1.775 3.24H18c-2 0-4 1.994-4 3.994v2c0 1.305.853 2.606 2 3.355v.645l-10 .001s5.977-16.91 6.179-17.212c.254-.469.75-.788 1.321-.788z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi127;
